import JsTabs from 'js-tabs';

if (document.getElementById('js-tabs')) {
    const myTabs = new JsTabs({
        elm: '#js-tabs',
        shouldScrollTabIntoView: false,
    });
    myTabs.init();
}
